import React from 'react';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { SpotifyTrack } from '../types';
import { sendTelemetryEvent } from '../services/telemetryService';
import '../styles/RecommendationsList.css';

interface RecommendationsListProps {
  recommendations: SpotifyTrack[];
}

const RecommendationsList: React.FC<RecommendationsListProps> = ({ recommendations }) => {
  return (
    <div className="recommendations-list">
      <div className="recommendations-header">
        <h3>Recommendations ({recommendations.length})</h3>
      </div>

      <div className="tracks-container">
        {recommendations.length === 0 ? (
          <p className="no-recommendations">No recommendations yet. Adjust your settings and try again.</p>
        ) : (
          recommendations.map(track => (
            <div key={track.id} className="track-card">
              {track.album.images.length > 0 ? (
                <img
                  src={track.album.images[0]?.url}
                  alt={`${track.album.name} cover`}
                  className="track-album-art"
                />
              ) : (
                <div className="track-album-art track-album-placeholder">♪</div>
              )}
              
              <div className="track-info">
                <div className="track-name">{track.name}</div>
                <div className="track-artist">
                  {track.artists.map(artist => artist.name).join(', ')}
                </div>
              </div>

              <a
                href={track.platformUrl || `https://open.spotify.com/track/${track.id}`}
                target="_blank"
                rel="noopener noreferrer"
                className="track-open-spotify"
                title={`Open in ${track.platformName || 'Spotify'}`}
                aria-label={`Open in ${track.platformName || 'Spotify'}`}
                onClick={(e) => {
                  sendTelemetryEvent({ eventType: 'recommendation_clicked', platform: track.platformName === 'YouTube Music' ? 'ytmusic' : 'spotify', trackId: track.id });
                  e.stopPropagation();
                }}
              >
                <OpenInNewIcon style={{ width: 18, height: 18 }} />
              </a>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default RecommendationsList;
